<template>
  <div class="mobile_nav_container" v-if="mobileNav.isExpand">
    <ul class="primary_list_mob">
      <li
        v-for="(menuItem, index) in menuItems"
        class="paragraph"
        :class="{
          primary_nav_item: index !== menuItems.length - 1,
        }"
        :key="menuItem.toState"
        @click="onPrimaryMenuClick(menuItem)"
      >
        <div v-if="index !== menuItems.length - 1">
          <div class="primary_title">
            <p class="mb_0 py_10">{{ $t(menuItem.label) }}</p>
            <span v-if="menuItem.hasChildinMob">
              <fluent-icon
                v-if="activePrimaryMenu && menuItem.id === activePrimaryMenu.id"
                class=""
                icon="chevron-up"
              />
              <fluent-icon v-else class="" icon="chevron-down" />
            </span>
          </div>

          <ul
            v-if="activePrimaryMenu && menuItem.id === activePrimaryMenu.id"
            class="secondary_list_mob my_4 ml_14"
          >
            <router-link
              v-for="item in activeSecondaryList"
              :key="item.key"
              :to="item && item.toState"
              active-class="is-active"
              exact
              @click.native="toggleMobileMenu(false)"
            >
              <li class="secondary_item ">
                <fluent-icon
                  :icon="item.icon"
                  :view-box="item.viewBox ? item.viewBox : '0 0 24 24'"
                  class="secondary-menu--icon"
                  size="14"
                />
                {{ $t(`SIDEBAR.${item.label}`) }}
              </li>
            </router-link>
          </ul>
        </div>
      </li>
    </ul>
  </div>
  <div v-else class="primary--sidebar ">
    <div class="scroll-container-wrapper">
      <button
        v-if="isScrollable && !isAtTop"
        class="scroll-btn up"
        @click="scrollUp"
      >
        ▲
      </button>
      <nav
        ref="scrollContainer"
        class="menu vertical scroll-container"
        @scroll="checkScroll"
      >
        <primary-nav-item
          v-for="menuItem in menuItems"
          :key="menuItem.toState"
          :icon="menuItem.icon"
          :name="menuItem.label"
          :to="menuItem.toState"
          :is-child-menu-active="menuItem.key === activeMenuItem"
        />
      </nav>
      <button
        v-if="isScrollable && !isAtBottom"
        class="scroll-btn down"
        @click="scrollDown"
      >
        ▼
      </button>
    </div>
    <!-- <div class="menu vertical user-menu">
      <notification-bell />
      <agent-details @toggle-menu="toggleOptions" />
      <options-menu
        :show="showOptionsMenu"
        @toggle-accounts="toggleAccountModal"
        @show-support-chat-window="toggleSupportChatWindow"
        @key-shortcut-modal="$emit('key-shortcut-modal')"
        @close="toggleOptions"
      />
    </div> -->
  </div>
</template>
<script>
import PrimaryNavItem from './PrimaryNavItem';
// import NotificationBell from './NotificationBell';
import { mapGetters } from 'vuex';
import { frontendURL } from 'dashboard/helper/URLHelper';
import secondaryNavMixin from './secondaryNavMixin';
import { getSidebarItems } from '../config/default-sidebar';
import helperMixin from 'shared/mixins/helperMixin';

export default {
  components: {
    PrimaryNavItem,
    // NotificationBell,
  },
  mixins: [secondaryNavMixin, helperMixin],
  props: {
    logoSource: {
      type: String,
      default: '',
    },
    installationName: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
    menuItems: {
      type: Array,
      default: () => [],
    },
    activeMenuItem: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showOptionsMenu: false,
      isScrollable: false,
      isAtTop: true,
      isAtBottom: false,
      activePrimaryMenu: null,
    };
  },
  computed: {
    ...mapGetters({
      mobileNav: 'getMobileNav',
      currentRole: 'getCurrentRole',
      currentUser: 'getCurrentUser',
    }),
    menuConfig() {
      const { secondaryMenu } = getSidebarItems(this.accountId);
      const { name: currentRoute } = this.$route; // chenge this
      const activeSecondaryMenu =
        secondaryMenu.find(menuItem =>
          menuItem.routes.includes(currentRoute)
        ) || {};
      return activeSecondaryMenu;
    },
    activeSecondaryList() {
      const allMenu = getSidebarItems(this.accountId);
      const secondaryList = allMenu.secondaryMenu.find(
        el => el.parentNav === this.activePrimaryMenu?.id
      );
      return secondaryList?.menuItems || [];
    },
    subscriptionPlanId() {
      return this.currentUser?.plan_id;
    },
  },
  watch: {
    menuItems: {
      handler() {
        this.$nextTick(() => {
          this.checkScroll();
        });
      },
      deep: true, // Optional, only if menuItems contains nested changes
      immediate: true, // Optional, calls on initial mount
    },
  },
  mounted() {
    this.checkScroll();
    window.addEventListener('resize', this.checkScroll);
    this.$nextTick(() => {
      this.checkScroll();
      window.addEventListener('resize', this.checkScroll);
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.checkScroll);
  },

  methods: {
    frontendURL,
    toggleOptions() {
      this.showOptionsMenu = !this.showOptionsMenu;
    },
    toggleAccountModal() {
      this.$emit('toggle-accounts');
    },
    toggleSupportChatWindow() {
      window.$peasy.toggle();
    },

    scrollUp() {
      this.$refs.scrollContainer.scrollBy({
        top: -100,
        behavior: 'smooth',
      });
    },
    scrollDown() {
      this.$refs.scrollContainer.scrollBy({
        top: 100,
        behavior: 'smooth',
      });
    },
    checkScroll() {
      const container = this.$refs.scrollContainer;
      if (!container) return;

      const containerHeight = container.clientHeight;
      const contentHeight = container.scrollHeight;

      this.isScrollable = contentHeight > containerHeight;
      this.isAtTop = container.scrollTop === 0;
      this.isAtBottom =
        container.scrollTop + container.clientHeight >= container.scrollHeight;

      // console.log({containerHeight,contentHeight,isAtBottom:this.isAtBottom,isAtTop:this.isAtTop});
    },
    onPrimaryMenuClick(item) {
      if (item.id === this.activePrimaryMenu?.id) {
        this.activePrimaryMenu = null;
        return;
      }

      this.activePrimaryMenu = item;
      if (!item.hasChildinMob) {
        if (item.toState?.includes('pm-external')) {
          // ignore
        } else if (item.toState?.startsWith('https://')) {
          // with blank
          this.openInNewTab(item.toState);
        } else {
          this.$router.push({ name: item.toStateName });
        }
        this.toggleMobileMenu(false);
      }
    },
    toggleMobileMenu(isExpand) {
      // dispatch to vuex
      console.log('Toggling');
      // toggleMobileNav
      this.$store.dispatch('toggleMobileNav', {
        ...this.mobileNav,
        isExpand,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~dashboard/assets/scss/_variables.scss';
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.primary--sidebar {
  background-color: var(--w-500);
  display: flex;
  flex-direction: column;
  // width: var(--space-jumbo);
  width: $space-super;
  border-right: 1px solid var(--s-50);
  box-sizing: content-box;
  flex-shrink: 0;
  height: calc(100vh - 60px);
  // overflow-x: hidden;
  // overflow-y: auto;
  // overflow: hidden; // no scrollbar on this container, only nav scrolls internally
  position: relative;
}

.scroll-container-wrapper {
  position: relative;
  height: 100%;
}
.scroll-container {
  height: calc(100vh - 60px); // space for buttons
  overflow-y: auto;
  height: 100%;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;
}

.scroll-container::-webkit-scrollbar {
  width: 2px;
  background: transparent;
}

.scroll-container::-webkit-scrollbar-thumb {
  background: transparent;
}

.scroll-container:hover {
  // scrollbar-width: thin;
}

.scroll-container:hover::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
}

.scroll-btn {
  position: absolute;
  width: 100%;
  background: transparent;
  color: #fff;
  z-index: 10;
  height: 20px;
  font-size: 16px;
  cursor: pointer;
  &:hover {
    // background: var(--w-30);
  }
}

.scroll-btn.up {
  top: 0;
}
.scroll-btn.down {
  bottom: 0;
}

.menu {
  align-items: center;
  // margin-top: var(--space-medium);
}

.user-menu {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-end;
  margin-bottom: var(--space-normal);
}

.primary_list_mob {
  list-style: none;
}
.secondary_list_mob {
  list-style: none;
}
.primary_nav_item {
  border-bottom: 1px solid var(--s-75);
}
.primary_title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  p {
    color: var(--s-600);
  }
}

.secondary_item {
  display: flex;
  align-items: center;
  gap: 4px;
  color: var(--s-600);
  border-radius: var(--border-radius-normal);
  padding: var(--space-one) var(--space-slab);
  font-weight: var(--font-weight-medium);
}
</style>

<style>
.router-link-active .secondary_item,
.is-active .secondary_item {
  background: var(--w-30);
  color: var(--w-500);
  border-color: var(--w-25);
}
</style>
